import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TemplateCard from "../TemplateCard/TemplateCard";
import Pagination from "../Pagination/Pagination";
// import PublishDialog from "../../../TemplateBuilder/components/PublishDialog/PublishDialog";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import useDocFormsStore from "../../store/docFormsStore";

const useStyles = makeStyles((theme) => ({
	container: {
		backgroundColor: "#fff",
		marginTop: "16px",
		padding: "14px 16px",
		height: "100%",
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
	},
	gridContainer: {
		display: "flex",
		flexWrap: "wrap",
		gap: "16px",
		alignItems: "center",
	},
}));

export default function TemplateGrid({ setLoading, reloadTemplates }) {
	const classes = useStyles();
	const navigate = useNavigate();
	const [currentPage, setCurrentPage] = useState(1);
	const [templatesPerPage] = useState(10);

	// Get templates from Zustand store
	const templates = useDocFormsStore((state) => state.templates);
	const removeTemplate = useDocFormsStore((state) => state.removeTemplate);

	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	const handleClickMenuItem = (menu, template) => {
		switch (menu) {
			case "Delete":
				handleDeleteTemplate(template);
				break;
			case "Edit":
				handleEditTemplate(template);
				break;
			case "Publish":
				handlePublishTemplate(template);
				break;
			default:
				break;
		}
	};

	const handleDeleteTemplate = (template) => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then((result) => {
			if (result.isConfirmed) {
				removeTemplate(template.id);
				toast.success("Template deleted successfully!");
			}
		});
	};

	const handleEditTemplate = (template) => {
		navigate(`/template-builder/${template.id}`);
	};

	const handlePublishTemplate = (template) => {
		navigate(`/publish-template/${template.id}`);
	};

	// Calculate pagination
	const indexOfLastTemplate = currentPage * templatesPerPage;
	const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
	const currentTemplates = templates.slice(indexOfFirstTemplate, indexOfLastTemplate);

	return (
		<div className={classes.container}>
			<div className={classes.gridContainer}>
				{currentTemplates.map((template) => (
					<TemplateCard
						key={template.id}
						template={template}
						onClickMenu={handleClickMenuItem}
					/>
				))}
			</div>

			{/* <Pagination
				currentPage={currentPage}
				itemsPerPage={templatesPerPage}
				totalItems={templates.length}
				onPageChange={handlePageChange}
			/> */}
			{/* <PublishDialog
				open={openPublish}
				onClose={handleClosePublish}
				recipients={recipients}
				setRecipients={setRecipients}
				onPublish={handleSend}
			/> */}
		</div>
	);
}
